var _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle2, _circle3, _circle4, _g, _circle5, _circle6, _circle7, _g2, _circle8, _circle9, _circle10, _g3, _circle11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEngaged(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 270 270",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#fff;}.cls-1,.cls-2,.cls-5{stroke:#0b1320;stroke-linecap:round;stroke-linejoin:round;}.cls-2,.cls-5{fill:none;}.cls-2{stroke-dasharray:2.41 4.02;}.cls-4{clip-path:url(#clip-path);}.cls-6{clip-path:url(#clip-path-2);}.cls-7{clip-path:url(#clip-path-3);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 135,
    cy: 33.94,
    r: 28.94
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 221.59,
    cy: 223.96,
    r: 28.94
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 53.38,
    cy: 223.96,
    r: 28.94
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 135,
    cy: 149.47,
    r: 115.53
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.33,106.82V96.21a4,4,0,0,1,4-4H194.7a4,4,0,0,1,4,4v10.61Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.23,101.62a2.09,2.09,0,1,1,2.09-2.09A2.09,2.09,0,0,1,80.23,101.62Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88,101.62a2.09,2.09,0,1,1,2.08-2.09A2.1,2.1,0,0,1,88,101.62Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.74,101.62a2.09,2.09,0,1,1,2.08-2.09A2.1,2.1,0,0,1,95.74,101.62Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.33,106.82H198.67a0,0,0,0,1,0,0v71.72a4.8,4.8,0,0,1-4.8,4.8H76.14a4.8,4.8,0,0,1-4.8-4.8V106.82A0,0,0,0,1,71.33,106.82Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135,119.46h19.22a6.41,6.41,0,0,1,6.41,6.41v19.22A25.62,25.62,0,0,1,135,170.71h0a25.62,25.62,0,0,1-25.62-25.62v0A25.62,25.62,0,0,1,135,119.46Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135,157.9a12.83,12.83,0,0,0,11.12-6.44A12.82,12.82,0,0,0,135,145.08h0a12.8,12.8,0,0,0-11.12,6.44A12.82,12.82,0,0,0,135,157.9Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 134.96,
    cy: 137.32,
    r: 5.05
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 135,
    cy: 33.94,
    r: 28.94
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 135,
    cy: 33.94,
    r: 28.94
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158.3,62.55l-.81-3.21c-.75-2.27-4-4.82-16.87-4.79l-1.6,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131,62.55l-1.6-8c-12.86,0-16.07,2.41-16.87,4.82l-.81,3.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.05,31.82a1.58,1.58,0,0,1,1.61,1.61v3.21a1.61,1.61,0,0,1-1.61,1.61s-2.41,6.42-4,8.83c-1,1.5-2.41,4-8,4s-7-2.52-8-4c-1.61-2.41-4-8.83-4-8.83a1.61,1.61,0,0,1-1.61-1.61V33.43A1.61,1.61,0,0,1,123,31.82a1.58,1.58,0,0,0,1.61,1.61,19,19,0,0,0,1.6-6.43c3.22,0,12.82-.48,14.46-3.21,0,3.21,3.22,6.42,3.22,6.42A3.68,3.68,0,0,0,147.05,31.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.34,33.43A1.61,1.61,0,0,1,123,31.82a1.58,1.58,0,0,0,1.61,1.61,19,19,0,0,0,1.6-6.43c3.22,0,12.82-.48,14.46-3.21,0,3.21,3.22,6.42,3.22,6.42a3.72,3.72,0,0,0,3.21,1.61V27s0-8.84-8-8.84c.8-1.6-1.1-2.41-4-2.41-13.66,0-13.66,12.86-13.66,12.86Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 129.38,
    y1: 35.24,
    x2: 132.59,
    y2: 35.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 130.98,
    y1: 36.37,
    x2: 130.98,
    y2: 35.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 137.41,
    y1: 35.24,
    x2: 140.62,
    y2: 35.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 139.02,
    y1: 36.37,
    x2: 139.02,
    y2: 35.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 135,
    cy: 56.12,
    r: 1.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 135,
    y1: 62.55,
    x2: 135,
    y2: 57.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.93,41.21a3.21,3.21,0,0,1-2.15,5.6H139"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 137.41,
    cy: 46.8,
    r: 1.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.59,45.19h0a2.85,2.85,0,0,1-2.41-1.61"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 135,
    cy: 33.94,
    r: 28.94
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 221.59,
    cy: 223.96,
    r: 28.94
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 221.59,
    cy: 223.96,
    r: 28.94
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.45,234.11a15.42,15.42,0,0,1-1.93-5.11c-.66-2.44-.53-6.22-.53-9.63-.32-10.3-3.17-12.19-4.3-13.23a4,4,0,0,0-3.07-.68c.45-1.46-1.47-2.15-4.91-2.38-7.93-.31-11.28.58-15,3s-5.84,8.38-5.52,13.33a37.92,37.92,0,0,1-1.17,11.71c-.6,2.21-1.77,3.34-2,4.67-.42,3.63,2.37,3.27,2.37,3.27H218.8a14.41,14.41,0,0,1-6.46-6.55,51.18,51.18,0,0,1-2.9-9.82,22.14,22.14,0,0,1,0-4.1s14.44.1,21.18-4.86c0,0-1.4,4.65,3.38,8.14,0,0-1.09,9.74-5.09,13.92A16,16,0,0,1,224.7,239h14.11c1.75,0,2.22-.85,2.36-1.83A7.05,7.05,0,0,0,240.45,234.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.49,242.9l-.63-.47s-2.89.78-3.88.89c-10,1.13-12.69,7.16-12.69,7.16l23.76,4.71.77-.16.77.16,23.77-4.71s-2.66-6-12.69-7.16c-1-.11-3.88-.89-3.88-.89l-.63.47L225,244.13a11.51,11.51,0,0,1-8.29,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.42,223.36h0a3.94,3.94,0,0,1,3.54,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.27,223.36h0a3.86,3.86,0,0,1,3.44-.05l.1.05"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 221.59,
    cy: 223.96,
    r: 28.94
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 53.38,
    cy: 223.96,
    r: 28.94
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 53.38,
    cy: 223.96,
    r: 28.94
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.43,220.38A1.58,1.58,0,0,1,67,222v3.21a1.61,1.61,0,0,1-1.61,1.61s-2.41,6.42-4,8.83c-1,1.5-2.41,4-8,4s-7-2.52-8-4c-1.61-2.41-4-8.83-4-8.83a1.61,1.61,0,0,1-1.6-1.61V222a1.61,1.61,0,0,1,1.6-1.61A1.58,1.58,0,0,0,42.94,222a19,19,0,0,0,1.61-6.43c3.21,0,12.82-.48,14.46-3.21,0,3.21,3.21,6.42,3.21,6.42A3.68,3.68,0,0,0,65.43,220.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.73,222a1.61,1.61,0,0,1,1.6-1.61A1.58,1.58,0,0,0,42.94,222a19,19,0,0,0,1.61-6.43c3.21,0,12.82-.48,14.46-3.21,0,3.21,3.21,6.42,3.21,6.42a3.72,3.72,0,0,0,3.21,1.61v-4.82s0-8.84-8-8.84c.8-1.6-1.1-2.41-4-2.41-13.65,0-13.65,12.86-13.65,12.86Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 47.76,
    y1: 223.8,
    x2: 50.97,
    y2: 223.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 49.37,
    y1: 224.94,
    x2: 49.37,
    y2: 223.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 55.79,
    y1: 223.8,
    x2: 59.01,
    y2: 223.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 57.4,
    y1: 224.94,
    x2: 57.4,
    y2: 223.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51,233.06a4.41,4.41,0,0,0,4.82,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73,261.89H34.85V250a6.22,6.22,0,0,1,6.22-6.22h8.85l.07.08a4.39,4.39,0,0,0,6.67-.08H66.79A6.22,6.22,0,0,1,73,250Z"
  }))), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 53.38,
    cy: 223.96,
    r: 28.94
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngaged);
export default __webpack_public_path__ + "static/media/engaged.17470759f7d541ab1b8cd50b9663d682.svg";
export { ForwardRef as ReactComponent };